// Modal.js
import React from 'react';

const Modal = ({ onClose, children }) => {
  return (
    <div className="rt345">
      <div className="rt345-content">
        <span className="close" style={{color:"red"}} onClick={onClose}>&times;</span>
        {children}
      </div>
    </div>
  );
};

export default Modal;
